/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AddInputs */



/**
* | output |
* | --- |
* | "Add" |
*
* @param {AddInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const add = /** @type {((inputs?: AddInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AddInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter")
	if (locale === "de") return /** @type {LocalizedString} */ ("Hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавлять")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加")
	if (locale === "ja") return /** @type {LocalizedString} */ ("追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जोड़ना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar")
	return /** @type {LocalizedString} */ ("Add")
});